"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientMetricReportMediaType = void 0;
var ClientMetricReportMediaType;
(function (ClientMetricReportMediaType) {
    ClientMetricReportMediaType[ClientMetricReportMediaType["AUDIO"] = 0] = "AUDIO";
    ClientMetricReportMediaType[ClientMetricReportMediaType["VIDEO"] = 1] = "VIDEO";
})(ClientMetricReportMediaType = exports.ClientMetricReportMediaType || (exports.ClientMetricReportMediaType = {}));
exports.default = ClientMetricReportMediaType;
//# sourceMappingURL=ClientMetricReportMediaType.js.map